var _style, _g, _polyline, _defs, _defs2, _defs3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSlfinance2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 283.5",
    style: {
      enableBackground: "new 0 0 595.3 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#422771;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n\t.st2{clip-path:url(#SVGID_00000003788624896775315880000017366276980294432930_);fill:#089BD3;}\r\n\t.st3{clip-path:url(#SVGID_00000072265576602549554440000012962637997287920040_);fill:#3A5293;}\r\n\t.st4{clip-path:url(#SVGID_00000057119372479940897670000018220383971715166354_);fill:#422771;}\r\n\t.st5{fill:#1D1D1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 141.4,
    y1: 317.5,
    x2: 214.1,
    y2: 317.5
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "315.5,141.7 315.5,165.9 351.8,165.9 351.8,141.7 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 41.2,
    y: 105.4,
    width: 72.6,
    height: 24.2
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#422771"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033329295504054697910000013045354358184950444_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: 105.4,
    style: {
      clipPath: "url(#SVGID_00000033329295504054697910000013045354358184950444_)",
      fill: "#089BD3"
    },
    width: 72.6,
    height: 24.2
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000053510003810559838110000013907720967386040753_",
    x: 41.2,
    y: 129.6,
    width: 54.5,
    height: 24.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131324965456371436490000012152662542902334877_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053510003810559838110000013907720967386040753_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: 129.6,
    style: {
      clipPath: "url(#SVGID_00000131324965456371436490000012152662542902334877_)",
      fill: "#3A5293"
    },
    width: 54.5,
    height: 24.2
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000183952171104086513560000003562982063712281754_",
    x: 41.2,
    y: 153.8,
    width: 36.3,
    height: 24.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005262304884755374240000011802475561518329260_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183952171104086513560000003562982063712281754_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: 153.8,
    style: {
      clipPath: "url(#SVGID_00000005262304884755374240000011802475561518329260_)",
      fill: "#422771"
    },
    width: 36.3,
    height: 24.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M123.6,172.8l5.5-12.5c4.8,3,11.9,4.8,18.2,4.8c6.2,0,8.2-1.3,8.2-3.6c0-7-30.8,1-30.8-19.9 c0-9.8,9.1-17.3,25.4-17.3c7.3,0,15.4,1.5,20.6,4.4l-5.5,12.4c-5.2-2.9-10.4-3.9-15-3.9c-6.2,0-8.4,1.7-8.4,3.7 c0,7.2,30.7-0.6,30.7,20.1c0,9.6-8.9,17.2-25.8,17.2C137.9,178.2,128.7,175.9,123.6,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.5,105.8h18.3v71.5h-18.3V105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222.1,120.6v6h15.6v5.8h-15.4v44.9h-6.8v-44.9h-9.1v-5.8h9.1v-6.3c0-9.1,5.4-15,15.3-15 c3.8,0,7.6,1.1,10.1,3.2l-2.3,5.1c-1.9-1.6-4.6-2.5-7.5-2.5C225.2,111.1,222.1,114.4,222.1,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250.7,110.6c0-2.6,2.2-4.8,5-4.8c2.8,0,5,2.1,5,4.7c0,2.8-2.1,5-5,5C252.9,115.5,250.7,113.3,250.7,110.6z  M252.2,126.6h6.8v50.7h-6.8V126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.4,147.9v29.4h-6.8v-28.7c0-10.7-5.6-16.2-15.2-16.2c-10.9,0-17.7,6.7-17.7,18.3v26.6h-6.8v-50.7h6.6v9.3 c3.7-6.2,10.5-9.7,19.3-9.7C313.9,126.2,322.4,133.3,322.4,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M385,126.6v50.7h-6.6v-10c-4.1,6.8-11.2,10.5-19.6,10.5c-14.5,0-25.2-10.5-25.2-25.8s10.8-25.7,25.2-25.7 c8.1,0,15,3.5,19.3,10v-9.6H385z M378.3,151.9c0-11.9-8.1-19.8-18.8-19.8c-10.8,0-18.9,7.9-18.9,19.8c0,11.9,8.1,19.8,18.9,19.8 C370.2,171.7,378.3,163.8,378.3,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M448.3,147.9v29.4h-6.8v-28.7c0-10.7-5.6-16.2-15.2-16.2c-10.9,0-17.7,6.7-17.7,18.3v26.6h-6.8v-50.7h6.6v9.3 c3.7-6.2,10.5-9.7,19.3-9.7C439.8,126.2,448.3,133.3,448.3,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M459.6,151.9c0-15.1,11-25.7,26.1-25.7c8.6,0,15.8,3.4,19.9,10l-5.1,3.5c-3.5-5.1-8.9-7.5-14.7-7.5 c-11.1,0-19.2,7.9-19.2,19.8c0,11.9,8.1,19.8,19.2,19.8c5.9,0,11.3-2.3,14.7-7.4l5.1,3.5c-4,6.6-11.3,10-19.9,10 C470.6,177.8,459.6,167.1,459.6,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M552.9,165.1l3.9,4.4c-4.5,5.4-11.5,8.3-19.5,8.3c-15.8,0-26.7-10.8-26.7-25.8c0-15,10.5-25.7,25.1-25.7 c13.6,0,23.8,9.9,24.3,24.2l-41.6,8.1c2.5,8.2,9.6,13.2,19.1,13.2C543.6,171.7,549.1,169.5,552.9,165.1z M517.2,151.5 c0,0.8,0,1.4,0.1,2.1l35.7-6.9c-1.4-8.3-8.1-14.6-17.4-14.6C524.8,132.1,517.2,140,517.2,151.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSlfinance2);
export default __webpack_public_path__ + "static/media/logo-slfinance2.67ee56b095e1d677785d4ceb7ede9112.svg";
export { ForwardRef as ReactComponent };